import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";

interface StyledDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  confirmFunction: () => void;
  dialogTitle?: string;
  dialogContent?: string;
}
export const StyledDialog = ({
  open,
  setOpen,
  confirmFunction,
  dialogTitle,
  dialogContent,
}: StyledDialogProps) => {
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirm = () => {
    setOpen(false);
    confirmFunction();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogContent}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Anuluj</Button>
        <Button onClick={handleConfirm} autoFocus>
          Potwierdź
        </Button>
      </DialogActions>
    </Dialog>
  );
};
